import { useAuthStore } from "@/data/useAuthStore";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ClubManagement } from "../components/club-management/club-management";

export const Route = createFileRoute("/club-management")({
  component: ClubManagement,
  loader: () => {
    const activeClubId = useAuthStore.getState().activeClubId;

    if (!activeClubId) {
      return redirect({
        to: "/home",
      });
    }
  },
});
